(function() {
	Vue.component('nominow-segmentbuilder-inttag', {
		props: {
			filter: {
				type: Object,
				required: true,
				default: () => ({
					id: String,
					valueop: String,
					value: String,
					maxvalue: String
				})
			}
		},
		template: `<div class="field is-grouped is-grouped-multiline">		
		<div class="control mui-textfield">
			<div :id="'dropdown'+filter.id" class="dropdown">
				<div class="dropdown-trigger js-toggle-dropdown" :data-toggle-dropdown-id="'dropdown'+filter.id">
					<button class="button is-deep" aria-haspopup="true" aria-controls="dropdown-menu">
						<span v-if="filter.valueop == null">- Select operator -</span>
						<span v-if="filter.valueop != null">{{showValue()}}</span>
						<span class="icon has-text-centered  is-small "><i aria-hidden="true" class="fa  fa-caret-down"></i></span>
					</button>
				</div>
				<div class="dropdown-menu is-deep" id="dropdown-menu" role="menu">
					<div class="dropdown-content">
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+filter.id+'integer'" value="&lt;" v-model="filter.valueop" @input="triggerUpdate">
							<a class="dropdown-item"><</a>
						</label>
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+filter.id+'integer'" value="&lt;=" v-model="filter.valueop" @input="triggerUpdate">
							<a class="dropdown-item"><=</a>
						</label>
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+filter.id+'integer'" value="=" v-model="filter.valueop" @input="triggerUpdate">
							<a class="dropdown-item">=</a>
						</label>
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+filter.id+'integer'" value="&gt;" v-model="filter.valueop" @input="triggerUpdate">
							<a class="dropdown-item">></a>
						</label>
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+filter.id+'integer'" value="&gt;=" v-model="filter.valueop" @input="triggerUpdate">
							<a class="dropdown-item">>=</a>
						</label>
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+filter.id+'integer'" value="Between" v-model="filter.valueop" @input="triggerUpdate">
							<a class="dropdown-item">Between</a>
						</label>
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+filter.id+'integer'" value="isnull" v-model="filter.valueop" @input="triggerUpdate">
							<a class="dropdown-item">Is Not Set</a>
						</label>
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+filter.id+'integer'" value="notnull" v-model="filter.valueop" @input="triggerUpdate">
							<a class="dropdown-item">Is Set</a>
						</label>
					</div>
				</div>
			</div>
			<label>Operator</label>

		</div>
		<div class="control mui-textfield" v-if="filter.valueop != 'isnull' && filter.valueop != 'notnull'">
			<input type="text" :id="filter.id + 'value'" :name="filter.id + 'value'" v-model="filter.value" @input="triggerUpdate"/>
			<label>Integer</label>
		</div>

		<div class="control mui-textfield" v-if="filter.valueop == 'Between'">
			<input type="text" :id="filter.id + 'maxvalue'" :name="filter.id + 'maxvalue'" v-model="filter.maxvalue"  @input="triggerUpdate"/>
			<label>and integer</label>
		</div>
		
		</div>`,
		methods: {
			triggerUpdate: function() {
				this.$emit('update', this.filter);
			},
			showValue: function() {
				switch (this.filter.valueop) {
					case 'isnull':
						return 'Is Not Set';
					case 'notnull':
						return 'Is Set';
					default:
						return this.filter.valueop;
				}
			}
		}
	});

	Vue.component('nominow-segmentbuilder-datetag', {
		model: {
			prop: 'filter',
			event: 'update'
		},
		props: {
			filter: {
				type: Object,
				required: true,
				default: () => ({
					id: String,
					valueop: String,
					value: String,
					maxvalue: String
				})
			}
		},
		data: function() {
			return {
				item: this.filter
			};
		},
		watch: {
			filter: function(newVal) {
				console.log('filter updated', newVal);
				this.item = newVal;
				if (this.$refs.dateInput) {
					this.$refs.dateInput.setVal(this.item.value);
				}
				if (this.$refs.maxdateInput) {
					this.$refs.maxdateInput.setVal(this.item.maxvalue);
				}
			}
		},
		template: `<div class="field is-grouped is-grouped-multiline">
		<div class="control mui-textfield">

			<div :id="'dropdown'+item.id" class="dropdown">
				<div class="dropdown-trigger js-toggle-dropdown" :data-toggle-dropdown-id="'dropdown'+item.id">
					<button class="button is-deep" aria-haspopup="true" aria-controls="dropdown-menu">
						<span v-if="item.valueop == null">- Select operator -</span>
						<span v-if="item.valueop != null">{{showValue()}}</span>
						<span class="icon has-text-centered  is-small "><i aria-hidden="true" class="fa  fa-caret-down"></i></span>
					</button>
				</div>
				<div class="dropdown-menu is-deep" id="dropdown-menu" role="menu">
					<div class="dropdown-content">
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+item.id+'date'" value="&lt;" v-model="item.valueop" />
							<a class="dropdown-item"><</a>
						</label>
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+item.id+'date'" value="&lt;=" v-model="item.valueop"/>
							<a class="dropdown-item"><=</a>
						</label>
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+item.id+'date'" value="=" v-model="item.valueop" />
							<a class="dropdown-item">=</a>
						</label>
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+item.id+'date'" value="&gt;" v-model="item.valueop" />
							<a class="dropdown-item">></a>
						</label>
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+item.id+'date'" value="&gt;=" v-model="item.valueop" />
							<a class="dropdown-item">>=</a>
						</label>
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+item.id+'date'" value="Between" v-model="item.valueop"/>
							<a class="dropdown-item">Between</a>
						</label>
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+item.id+'date'" value="isnull" v-model="item.valueop"/>
							<a class="dropdown-item">Is Not Set</a>
						</label>
						<label class="radiodropdown">
							<input type="radio" :name="'dropdown'+item.id+'date'" value="notnull" v-model="item.valueop" />
							<a class="dropdown-item">Is Set</a>
						</label>
					</div>
				</div>
			</div>
			<label>Operator</label>

		</div>
		<div class="control" v-if="item.valueop != 'isnull' && item.valueop != 'notnull'">
			<nominow-input-date v-model="item.value" label="Date":required="true" ref="dateInput"></nominow-input-date>
		</div>
		<div v-if="item.valueop == 'Between'">
			<nominow-input-date v-model="item.maxvalue" label="and date":required="true" ref="maxdateInput"></nominow-input-date>
		</div>

	</div>`,
		methods: {
			showValue: function() {
				switch (this.item.valueop) {
					case 'isnull':
						return 'Is Not Set';
					case 'notnull':
						return 'Is Set';
					default:
						return this.item.valueop;
				}
			}
		}
	});
})();
